//
// Used by Views/Shared/EditorTemplates/MultipleChoiceExtendedDataEditorViewModel
//

import {
    initializeMultipleChoiceExtendedComponentSelector
} from "../../Components/MultipleChoiceExtended/MultipleChoiceExtendedComponentSelector";


(function addMultipleChoiceExtendedComponentEditor() {
    const multipleChoiceExtendedTableContainers =
      Array.from(
        document
          .querySelectorAll<HTMLElement>(".multipleChoiceExtendedComponentSelector")
      );

      multipleChoiceExtendedTableContainers.map(element =>
        initializeMultipleChoiceExtendedComponentSelector((element))
      );
})();
